export default __webpack_public_path__ + "static/media/P900_CoC.b93d31fd.pdf";